<template>
<CCol col="12">
<CCard class="w-100 mb-1" :class="shadow ? 'shadow-sm' : ''" style="border-radius: 0;">
    <CCardHeader
        @click="collapse = !collapse"
        class="d-flex align-items-center justify-content-between cursor-pointer"
    >
        <span class="font-weight-bolder">{{ title }}</span>
        <FaIcon :icon="arrowIcon"/>
    </CCardHeader>

    <CCollapse :show="collapse">
        <CCardBody>
            <slot></slot>
        </CCardBody>
    </CCollapse>
</CCard>
</CCol>
</template>

<script>
export default {
    name: 'AccordionCollapse',

    props: {
        title: {
            required: true,
            type: String
        },
        shadow: {
            default: false,
            type: Boolean
        },
        collapsed: {
            default: false,
            type: Boolean
        }
    },

    data() {
        return {
            collapse: this.collapsed,
        }
    },

    computed: {
        arrowIcon() {
            return this.collapse ? 'arrow-up' : 'arrow-down'
        },
    }
}
</script>